import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-house" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-signal" }, null, -1)
const _hoisted_4 = { class: "center" }


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const year = new Date().getFullYear();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("table", _hoisted_1, [
      _createElementVNode("tr", null, [
        _createElementVNode("td", null, [
          _createVNode(_component_router_link, {
            to: "/",
            title: "home"
          }, {
            default: _withCtx(() => [
              _hoisted_2,
              _createTextVNode(" home")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("td", null, [
          _createVNode(_component_router_link, {
            to: "/status",
            title: "status"
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createTextVNode(" status")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(_component_router_view),
    _createElementVNode("footer", _hoisted_4, [
      _createElementVNode("p", null, "© " + _toDisplayString(_unref(year)) + " Pequla - Guild Core Application", 1)
    ])
  ], 64))
}
}

})